import { GzEasmMostRecentAssetsWebComponent } from './component/GzEasmMostRecentAssetsWebComponent';

export { GzEasmMostRecentAssetsWebComponent };
